/**
 * OneStop portal — shared `sx` tokens for government-facing surfaces.
 * Prefer MUI `Typography` `variant` + `theme.typography`; use these for TextField inputs,
 * Buttons, and cases where `variant` alone is not enough.
 */
export function cmsPortalTypography(theme) {
    const { typography: ty } = theme;
    return {
        navPrimary: {
            fontFamily: ty.body2.fontFamily,
            fontWeight: 500,
            fontSize: {
                xs: '0.6875rem',
                sm: '0.75rem',
                md: '0.8125rem',
                lg: '0.875rem',
            },
            textTransform: 'none',
        },
        navLogoSubline: {
            fontFamily: ty.caption.fontFamily,
            fontSize: ty.caption.fontSize,
            lineHeight: 1.2,
        },
        searchFieldInput: {
            fontFamily: ty.body1.fontFamily,
            fontSize: { xs: '0.9rem', sm: '0.9375rem', md: '1rem', lg: '1.0625rem' },
        },
        searchFieldButton: {
            fontFamily: ty.button.fontFamily,
            fontWeight: 700,
            fontSize: { xs: '0.9rem', sm: '0.9375rem', md: '1rem', lg: '1.0625rem' },
            textTransform: 'none',
        },
        agencyAccordionTitle: {
            fontFamily: ty.subtitle2.fontFamily,
            fontWeight: 600,
            fontSize: { xs: '0.875rem', sm: '0.9375rem' },
            lineHeight: 1.3,
            letterSpacing: '-0.01em',
        },
        agencyAccordionSubtitle: {
            fontFamily: ty.body2.fontFamily,
            fontWeight: 400,
            fontSize: { xs: '0.8125rem', sm: '0.875rem' },
            lineHeight: 1.45,
        },
        permitCardTitle: {
            fontFamily: ty.h6.fontFamily,
            fontWeight: 800,
            fontSize: { xs: '0.9375rem', sm: '1rem' },
            lineHeight: 1.28,
            letterSpacing: '-0.02em',
        },
        permitBody: {
            fontFamily: ty.body2.fontFamily,
            fontSize: ty.body2.fontSize,
            lineHeight: ty.body2.lineHeight,
            fontWeight: 400,
        },
        permitCta: {
            fontFamily: ty.button.fontFamily,
            fontSize: ty.body2.fontSize,
            fontWeight: 700,
            textTransform: 'none',
        },
        permitPaginationRange: {
            fontFamily: ty.body2.fontFamily,
            fontSize: ty.caption.fontSize,
            fontWeight: 600,
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            lineHeight: 1.4,
        },
        landingAgenciesSectionTitle: {
            fontFamily: ty.h6.fontFamily,
            fontWeight: 800,
            color: 'primary.dark',
            letterSpacing: '-0.02em',
            lineHeight: 1.3,
            fontSize: { xs: '1rem', sm: '1.0625rem', md: '1.125rem', lg: '1.1875rem', xl: '1.25rem' },
        },
        compactControl: {
            fontFamily: ty.button.fontFamily,
            fontWeight: 700,
            fontSize: '0.8125rem',
            textTransform: 'none',
        },
    };
}
